// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__1CZde","singleSlide":"Slider_singleSlide__1RKtA"};